import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const metricsApi = createApi({
  reducerPath: "metricsApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Metrics"],

  endpoints: (builder) => ({
    getMetrics: builder.query<any, void>({
      query: () => ({
        url: `${ApiEndpoints.getAllMetric}`,
        method: "GET",
      }),
      providesTags: ["Metrics"],
    }),
  }),
});

export const { useGetMetricsQuery } = metricsApi;
